import { TIDClient } from "@trimble-oss/trimble-id-react";

// Only the /local page uses this client; it also asks for the optional scopes that unlock skills and tool approval.
export const TID_SCOPES = [
  ...new Set([
    ...(import.meta.env.VITE_TID_SCOPES as string)
      .split(",")
      .map((s: string) => s.trim()),
    "skills",
    "tools",
  ]),
];

const tidClient = new TIDClient({
  config: {
    configurationEndpoint: import.meta.env.VITE_TID_CONFIG_ENDPOINT,
    clientId: import.meta.env.VITE_TID_CLIENT_ID,
    redirectUrl: window.location.origin + window.location.pathname,
    logoutRedirectUrl: window.location.origin + "/log-out",
    scopes: TID_SCOPES,
  },
});

export default tidClient;
